import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from '@env/environment';
import { CookieCiencuadras } from '../../utils/cookie-ciencuadras/cookie-ciencuadras';

@Component({
  selector: 'app-login-component',
  templateUrl: './login-component.component.html'

})
export class LoginComponent implements OnInit {

  id: number = 0;

  constructor(
    public dialogRef: MatDialogRef<LoginComponent>,
    public cookieCiencuadras: CookieCiencuadras
    ) { }

  ngOnInit(): void {
    
   
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  // currentUser
  // aindependiente@yopmail.com
  // dreamCode2020*

  //finkasyfinkas@hotmail.com
  //ciencuadras

  baseUrl = environment.environmenturl;
  cityUrl = environment.apiUrl;
  configfile = './assets/login-component/config-component.json';
  
  
  
  roleUser = parseInt(this.cookieCiencuadras.getCookie('loginUserType')) ? parseInt(this.cookieCiencuadras.getCookie('loginUserType')) : 2;

  processAuth(obj:any) {
    if(obj.detail.data.message === 'LOGIN-SUCCESS')
      this.dialogRef.close(obj);
  }

}
